import { render, staticRenderFns } from "./AdminNeedResponse.vue?vue&type=template&id=9af79a0e&scoped=true&"
import script from "./AdminNeedResponse.vue?vue&type=script&lang=js&"
export * from "./AdminNeedResponse.vue?vue&type=script&lang=js&"
import style0 from "./AdminNeedResponse.vue?vue&type=style&index=0&id=9af79a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af79a0e",
  null
  
)

export default component.exports